let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fcU7k")).then(() => parcelRequire('2dQJG'));